export const storeToolState = (storageName: string, state: Record<string, unknown> | string[]) => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(storageName, JSON.stringify(state))
  }

  return
}
